import { withRouter } from 'react-router-dom';
import NotFound from '../components/NotFound';

export default withRouter(NotFound);